// extracted by mini-css-extract-plugin
export default {"radio":"SuperRadio_radio__ZDUhf","label":"SuperRadio_label__q0Jsv","options":"SuperRadio_options__z8LWQ"};